import { render, staticRenderFns } from "./gallery-list-page.vue?vue&type=template&id=c3dd7c98&"
import script from "./gallery-list-page.vue?vue&type=script&lang=js&"
export * from "./gallery-list-page.vue?vue&type=script&lang=js&"
import style0 from "./gallery-list-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInfiniteScroll} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInfiniteScroll})
